import React, { useEffect } from "react";
import GetInTouchSection from "../GetInTouch/GetInTouch";
import "./contactUsPage.css";

const ContactUsPage: React.FC = () => {
    useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // remove if you want instant
    });
  }, []);
  const heroBg =
    "https://images.unsplash.com/photo-1534536281715-e28d76689b4d?q=80&w=1170&auto=format&fit=crop";

  return (
    <main className="contactRoot">
      {/* ================= HERO / BANNER ================= */}
      <section className="contactHeroSection">
        <article
          className="contactHeroBanner"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="contactHeroOverlay" />

          <div className="contactHeroContent">
            <span className="contactHeroChip">Contact Us</span>

            <h1 className="contactHeroTitle">
              Let’s Build Something <em>Amazing</em> Together
            </h1>

            <p className="contactHeroSubtitle">
              Share your ideas, challenges, or vision — our experts are ready to
              help you move from concept to reality.
            </p>
          </div>
        </article>
      </section>

      {/* ================= INTRO TEXT ================= */}
      <section className="contactIntroSection">
        <div className="contactIntroContainer">
          <div className="contactIntroGrid">
            <div className="contactIntroCol">
              <p className="contactIntroLead">
                Have a project in mind or need technical expertise?
              </p>
              <p>
                We collaborate, guide, and support you with the right solutions —
                from engineering to consulting.
              </p>
            </div>

            <div className="contactIntroCol">
              <p className="contactIntroLead">
                Startups. Enterprises. Visionaries.
              </p>
              <p>
                Reach out using the contact details below — we respond within 24
                hours.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= GET IN TOUCH ================= */}
      <section className="contactTouchSection">
        <GetInTouchSection />
      </section>

      {/* Spacer before footer */}
      <div style={{ height: "100px" }} />
    </main>
  );
};

export default ContactUsPage;
